import { useInputAction } from './input-action.model'
import type { IInputActionProps } from './input-action.types'
import { InputActionView } from './input-action.view'

export default function InputAction(props: IInputActionProps) {
  const model = useInputAction(props)
  return <InputActionView {...model} />
}
